import React, { PureComponent } from 'react';
import { size } from 'lodash-es';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { withRouter, RouteComponentProps } from 'react-router';
import { push } from 'connected-react-router';
import moment from 'moment';

import {
  loadOnCallServices,
  updateOnCallServices,
  updateAcceptSelectedOnCallPaymentServices,
  resetOnCallService,
} from '../../ducks';
import { AcceptPaymentForSelectedOnCallModal } from '../modal';
import {
  OnCallServicesForm,
  PricingInfoOnCallForm,
  PricingInfoOnCallFormFooter,
  PaymentReportDateForm,
} from '../forms';
import pricingInfoIntialValueSelector from '../../services/pricingInfoIntialValueSelector';
import {
  PageContent,
  PageHeader,
  PageDetails,
  PageTitleContainer,
  PageSubtitle,
} from '../../../common/components/styled';
import {
  Panel,
  PanelSectionGroup,
  PanelSection,
  Text,
  Grid,
  GridColumn,
  Button,
} from '../../../core/components/styled';
import translate from '../../../core/services/translate';
import confirm from '../../../core/services/confirm';
import { AppState } from '../../../store';

interface RouteParams {
  token: string;
}

interface Props extends RouteComponentProps<RouteParams> {
  vendorId: number;
  workOrdersInfo: any[];
  pricingInfo: any;
  isLoading: boolean;
  isSaving: boolean;
  haulerName?: string;
  errorMessage?: string;
  reset: any;
  loadOnCallServices(...args: any[]): any;
  resetOnCallService(...args: any[]): any;
}

interface State {
  isAcceptPaymentForSelectedRecurringModalOpen: boolean;
  isExpanded: boolean;
}

const AcceptPaymentForSelectedOnCallModalMock = AcceptPaymentForSelectedOnCallModal as any;

class OnCallServicesPage extends PureComponent<Props, State> {
  readonly state = {
    isAcceptPaymentForSelectedRecurringModalOpen: false,
    isExpanded: false,
  };

  componentWillUnmount() {
    const { resetOnCallService } = this.props;

    resetOnCallService();
  }

  onDateChange = async (event: any) => {
    const { match, vendorId, loadOnCallServices } = this.props;
    const token = match.params.token;
    const date = moment(event).format('MM/DD/YYYY');

    await loadOnCallServices(vendorId, token, date);
  };

  // Accept
  openAcceptPaymentForSelectedRecurringModal = (event: any) => {
    this.setState({ isAcceptPaymentForSelectedRecurringModalOpen: true });
    event.stopPropagation();

    return false;
  };

  closeAcceptPaymentForSelectedRecurringModal = async (formPristine: boolean) => {
    if (!formPristine) {
      if (!(await confirm(translate('common.alertMessages.leavePageWithoutSaving')))) {
        return;
      }
    }

    this.props.reset('acceptPaymentForSelected');
    this.setState({ isAcceptPaymentForSelectedRecurringModalOpen: false });
  };

  toggle = () => {
    this.setState(({ isExpanded }) => ({
      isExpanded: !isExpanded,
    }));
  };

  render() {
    const { pricingInfo, isLoading, isSaving, haulerName, errorMessage, vendorId } = this.props;

    return (
      <PageContent>
        <PageHeader withSubTitle>
          <PageDetails>
            <PageTitleContainer>
              {/* {(!errorMessage || (!!size(workOrdersInfo) || workOrdersInfo.length > 1)) && (
                // <PageTitle>{translate('opportunity.opportunities.currentOpportunities')}</PageTitle>
              )} */}
            </PageTitleContainer>
          </PageDetails>
        </PageHeader>
        <PageTitleContainer>
          <PageSubtitle size="medium" margin="small small small">
            {haulerName}
          </PageSubtitle>
        </PageTitleContainer>
        <Panel>
          <PanelSectionGroup isLoading={isLoading}>
            <PaymentReportDateForm {...this.props} onDateChange={this.onDateChange} />
            <Panel>
              {!!size(pricingInfo) && <PricingInfoOnCallForm vendorId={vendorId} />}
              {(!size(pricingInfo) || pricingInfo.length < 1) && (
                <Text block weight="medium" size="large" margin="xxLarge xxGrande large ">
                  {translate('payment.noRecord')}
                </Text>
              )}
            </Panel>

            {errorMessage && (
              <Panel>
                <Text block weight="medium" size="large" color="alert" margin="xxLarge xxGrande large ">
                  Error:
                </Text>
                <Text block weight="medium" size="small" color="gray">
                  {errorMessage}
                </Text>
              </Panel>
            )}
          </PanelSectionGroup>
        </Panel>
        <Panel>
          <PanelSectionGroup isLoading={isLoading || isSaving}>
            <PanelSection centered>{!!size(pricingInfo) && <OnCallServicesForm vendorId={vendorId} />}</PanelSection>
          </PanelSectionGroup>
        </Panel>
        <Panel>
          <PanelSectionGroup isLoading={isLoading}>
            <Grid padding="no no no no" multiLine>
              {!!size(pricingInfo) && (
                <GridColumn size="12/12" align="right">
                  {!!size(pricingInfo) && <PricingInfoOnCallFormFooter />}
                  <Button
                    background-color="transparent"
                    color="primary"
                    size="small"
                    onClick={this.openAcceptPaymentForSelectedRecurringModal}
                    disabled={pricingInfo.acceptedWOCount <= 0}
                    margin="small xSmall small"
                  >
                    {translate('payment.acceptPaymentForSelected')}
                  </Button>{' '}
                  {this.state.isAcceptPaymentForSelectedRecurringModalOpen && (
                    <AcceptPaymentForSelectedOnCallModalMock
                      {...this.props}
                      onCancel={this.closeAcceptPaymentForSelectedRecurringModal}
                    />
                  )}
                </GridColumn>
              )}
            </Grid>
          </PanelSectionGroup>
        </Panel>
      </PageContent>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  workOrdersInfo: state.payments.onCallServices.workOrdersInfo || [],
  pricingInfo: state.payments.onCallServices.pricingInfo,
  paymentInfo: state.payments.onCallServices.paymentInfo,
  issueType: state.payments.onCallServices.issueType,
  haulerName: state.payments.onCallServices.haulerName,
  errorMessage: state.payments.onCallServices.errorMessage,
  isLoading: state.payments.onCallServices.isLoading,
  isSaving: state.payments.onCallServices.isSaving,
  initialValues: pricingInfoIntialValueSelector(state.payments.onCallServices.pricingInfo),
});

const mapDispatchToProps = {
  loadOnCallServices,
  updateOnCallServices,
  updateAcceptSelectedOnCallPaymentServices,
  resetOnCallService,
  push,
  reset,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OnCallServicesPage));
